export const INFO = {
  DEFAULT: '#0033b0',
} as const;
